import React, { Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import Loader from "../../components/Loader";
import Home from "./../Home";
import HomeTest from "./../Home/HomeTest";
import HomeSimple from "./../HomeSimple";
import Search from "./../Search";
import Profile from "./../Profile";
import Library from "./../Library";
import MyMusic from "./../MyMusic";
import Playlists from "../Playlists";
import Feed from "./../Feed/Feed";

import Albums from "./../Albums";
import Nft from "./../Nft";
import Subscription from "./../Subscription";
import PowerPlays from "./../PowerPlays";
import ExploreMore from "./../ExploreMore";
import MusicPlayer from "./../MusicPlayer";
import UploadMusic from "./../UploadMusic";
import UploadVideo from "./../UploadVideo";
import UploadAlbum from "./../UploadAlbum";
import Leaderboard from "./../Leaderboard";
import GlobalLeaderboard from "./../Leaderboard/GlobalLeaderboard";
import AddFeatureMusic from "./../AddFeatureMusic";
import EditProfile from "./../EditProfile";
import Gallery from "./../Gallery";
import Wallet from "./../Wallet";
import TransactionHistory from "./../TransactionHistory";
import PlayQueue from "./../PlayQueue";
import BuyBidInfo from "./../BuyBidInfo";
import PayForNft from "./../PayForNft";
import Upgrade from "./../Upgrade";
import Notifications from "./../Notifications";
import SongDetails from "./../SongDetails";
import ArtistProfile from "./../ArtistProfile";
import Follow from "./../Follow";
import BuyInfo from "./../BuyInfo";
import PlaylistNftDetail from "../PlaylistNftDetail";
import UnlockedAssets from "../UnlockedAssets";
import PlaylistStatics from "./../PlaylistStatics";
import SongDetail from "../SongDetail";
import Streaming from "../Streaming/Streaming";
import Recordings from "../Recordings";
import PaypalSuccess from "../../components/PaypalSuccess";
import MusicDetailsCard from "../../pages/MyMusic/MusicDetailsCard";
import VideoPlayerPage from "../VideoPlayer/VideoPlayerPage";
import AdGate from "../../components/AdGate";
import TestCharts from "../TestCharts";
import StreamKeys from "../StreamKeys";
import MySongRequests from "../MySongRequests";
import Insights from "../Insights";
import Missions from "../Missions";
import Leaderboards from "../Leaderboards";
import NotificationSettings from "../NotificationSettings";
// import DAW from "../DAW";
// import ScreeningRoom from "../ScreeningRoom";
// import Events from "../Events";
// import EventDetail from "../EventDetail";
// import CreateEvent from "../CreateEvent";
// import MyTickets from "../MyTickets";
// import TicketView from "../TicketView";
// import Advertisement from "../../components/Advertisement";
// import StreamShow from "../../components/Stream/StreamShow";

export default function ContentRouter(props) {
  return (
    <Suspense fallback={<Loader />}>
    <Switch>
      <Route
        exact
        path={`${props.match.url}`}
        render={(props) => <Home {...props} />}
      />
      <Route
        exact
        path={[
            `${props.match.url}/home`,
            `${props.match.url}/calendar`,
            `${props.match.url}/collection`,
            `${props.match.url}/studio`,
            `${props.match.url}/auction`,
            `${props.match.url}/settings`
        ]}
        render={(props) => <Home {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/home/:tab`}
        render={(props) => <Home {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/test-charts`}
        render={(props) => <TestCharts {...props} />}
      />
<Route
        exact
        path={`${props.match.url}/search`}
        render={(props) => <Search {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/library`}
        render={(props) => <Library {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MySongRequests`}
        render={(props) => <MySongRequests {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Feed`}
        render={(props) => <Feed {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/profile`}
        render={(props) => <Profile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Premium`}
        render={(props) => <Profile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MyMusic`}
        render={(props) => <MyMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MyMusic/:id`}
        render={(props) => <MyMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/AlbumDetail/:albumId`}
        render={(props) => <MyMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MyAlbumDetail/:albumId`}
        render={(props) => <MyMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Music/:playListId`}
        render={(props) => <MyMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/video/:playListId`}
        render={(props) => <MusicDetailsCard {...props} activeTab="Video" />}
      />
      <Route
        exact
        path={`${props.match.url}/video-player/:playListId/:videoId?`}
        render={(props) => <VideoPlayerPage {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Playlists`}
        render={(props) => <Playlists {...props} />}
      />

      <Route
        exact
        path={`${props.match.url}/Albums`}
        render={(props) => <Albums {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Albums/:_id`}
        render={(props) => <Albums {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/TopNft`}
        render={(props) => <Nft {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Nft`}
        render={(props) => <Nft {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Nft/:tab`}
        render={(props) => <Nft {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Subscription`}
        render={(props) => <Subscription {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/PowerPlays`}
        render={(props) => <PowerPlays {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/UnlockedAssets/Music`}
        render={(props) => <UnlockedAssets {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/UnlockedAssets/Playlist`}
        render={(props) => <UnlockedAssets {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/unlockedAssets`}
        render={(props) => <Nft {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/feature/:id`}
        render={(props) => <ExploreMore {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/searchMusic/:id`}
        render={(props) => <ExploreMore {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/searchStudio/:id`}
        render={(props) => <ExploreMore {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/searchArtist/:id`}
        render={(props) => <ExploreMore {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MusicPlayer`}
        render={(props) => <MusicPlayer {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/UploadMusic`}
        render={(props) => <UploadMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/UploadVideo`}
        render={(props) => <UploadVideo {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/UploadAlbum`}
        render={(props) => <UploadAlbum {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Analytics`}
        render={(props) => <Leaderboard {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Leaderboard`}
        render={(props) => <Leaderboard {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Leaderboard/:id`}
        render={(props) => <Leaderboard {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/GlobalLeaderboard`}
        render={(props) => <GlobalLeaderboard {...props} />}
      />
      {/* Gamification v2 (docs/GAMIFICATION_V2.md) */}
      <Route
        exact
        path={`${props.match.url}/Leaderboards`}
        render={(props) => <Leaderboards {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Missions`}
        render={(props) => <Missions {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Insights/streams/:channelName`}
        render={(props) => <Insights {...props} />}
      />
      <Route
        exact
        path={[`${props.match.url}/Insights`, `${props.match.url}/Insights/:tab`]}
        render={(props) => <Insights {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Settings/Notifications`}
        render={(props) => <NotificationSettings {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/AddFeatureMusic`}
        render={(props) => <AddFeatureMusic {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/EditProfile`}
        render={(props) => <EditProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Gallery`}
        render={(props) => <Gallery {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Gallery/:id`}
        render={(props) => <Gallery {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Wallet`}
        render={(props) => <Wallet {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Wallet/:addBalance`}
        render={(props) => <Wallet {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/TransactionHistory`}
        render={(props) => <TransactionHistory {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/PlayQueue`}
        render={(props) => <PlayQueue {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/BuyBidInfo/:id`}
        render={(props) => <BuyBidInfo {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/PayForNft`}
        render={(props) => <PayForNft {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Upgrade`}
        render={(props) => <Upgrade {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Notifications`}
        render={(props) => <Notifications {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/SongDetails/:id`}
        render={(props) => <SongDetails {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/PlaylistNftDetail/:nftId`}
        render={(props) => <PlaylistNftDetail {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/ArtistProfile/:id`}
        render={(props) => <ArtistProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/ArtistProfile/studio/:id`}
        render={(props) => <ArtistProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/ArtistProfile/collection/:id`}
        render={(props) => <ArtistProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/ArtistProfile/music/:id`}
        render={(props) => <ArtistProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/ArtistProfile/music/albums/:id`}
        render={(props) => <ArtistProfile {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Follow/:id`}
        render={(props) => <Follow {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/Following/:id`}
        render={(props) => <Follow {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/BuyInfo/:id`}
        render={(props) => <BuyInfo {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/SellAuction/:id`}
        render={(props) => <BuyInfo {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/SellAuctionPlayList/:playlistNftId`}
        render={(props) => <BuyInfo {...props} />}
      />
      {/* <Route
        exact
        path={`${props.match.url}/PlaylistDetail/:id`}
        render={(props) => <PlaylistDetail {...props} />}
      /> */}
      <Route
        exact
        path={`${props.match.url}/PlaylistStatics/:playListId/:createdBy`}
        render={(props) => <PlaylistStatics {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/MyNft/:nftId`}
        render={(props) => <SongDetail {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/SongDetail/:nftId`}
        render={(props) => <SongDetail {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/NftDetail/:nftId`}
        render={(props) => <SongDetail {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/LiveVideoStreaming/:playlistId`}
        render={(props) => <AdGate isLivestream={true}><Streaming {...props} /></AdGate>}
      />
    <Route
        exact
        path={`${props.match.url}/Streaming/:playlistId`}
        render={(props) => <AdGate isLivestream={true}><Streaming {...props} /></AdGate>}
    />
      <Route
        exact
        path={`${props.match.url}/Recordings`}
        render={(props) => <Recordings {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/StreamKeys`}
        render={(props) => <StreamKeys {...props} />}
      />
      {/* <Route
        exact
        path={`${props.match.url}/streams/:id`}
        render={(props) => <StreamShow {...props} />}
      /> */}
      <Route
        exact
        path={`${props.match.url}/payment/paypal/intermediate`}
        render={(props) => <PaypalSuccess {...props} />}
      />
      <Route
        exact
        path={`${props.match.url}/payment/paypal/failed`}
        render={(props) => <PaypalSuccess {...props} />}
      />
      {/* <Route
        exact
        path={`${props.match.url}/daw`}
        render={(props) => <DAW {...props} />}
      /> */}
      {/* <Route
        exact
        path={`${props.match.url}/tickets/:ticketId`}
        render={(props) => <TicketView {...props} />}
      /> */}
      {/* Catch-all route - redirect to home if no match */}
      <Route render={() => <Redirect to={`${props.match.url}/home`} />} />
    </Switch>
    </Suspense>
  );
}
